var LoginCtrl = function (AppUser, $state, $sessionStorage) {
    this._AppUser = AppUser;
    this._state = $state;
    this._sessionStorage = $sessionStorage;
    this.credentials = {};
    this.hasErrors = false;
    this.formSubmitted = false;
};

LoginCtrl.prototype.login = function () {
    var self = this;
    
    this.formSubmitted = true;
    
    this._AppUser.login(this.credentials,
        function (response) {
            self._state.go('app.orderlist', {type: 'scooter'});
            self._sessionStorage.userRole = response.role;
            self._sessionStorage.username = response.user.username;
        },
        function (error) {
            self.hasErrors = true;
            console.log('error', error);
        }
    );
};

module.exports = LoginCtrl;



// WEBPACK FOOTER //
// ./client/src/app/modules/login/LoginCtrl.js